export const messages = {
  en: {
    couponShopPoolDetail: {
      queryCondition: 'Query Conditions',
      enterCoupon: 'Please enter coupon',
      selectPurchaseTime: 'Please select purchase time',
      enterMemberName: 'Please enter member name',
      enterPhone: 'Please enter phone number',
      shopPurchaseRecord: 'Shop Purchase Records',
      detailId: 'Detail ID',
      couponName: 'Coupon',
      faceValue: 'Face Value',
      giveCount: 'Give Count',
      validity: 'Validity',
      memberName: 'Member Name',
      phone: 'Phone',
      orderNo: 'Order No'
    }
  },
  zh: {
    couponShopPoolDetail: {
      queryCondition: '查询条件',
      enterCoupon: '请输入优惠券',
      selectPurchaseTime: '请选择购买时间',
      enterMemberName: '请输入会员名称',
      enterPhone: '请输入手机号',
      shopPurchaseRecord: '商家购买记录',
      detailId: '商家赠送记录ID',
      couponName: '优惠券',
      faceValue: '面值',
      giveCount: '赠送数量',
      validity: '有效期',
      memberName: '会员名称',
      phone: '手机号',
      orderNo: '订单编号'
    }
  }
}